module.exports = __webpack_public_path__ + "static/media/decentralized.78070b23.svg";